import { Box, Card, Grid, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { HomeServiceDashboard } from "generated/openApi";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { ServiceChart } from "./ServiceChart";
import { ServiceTable } from "./ServiceTable";

export const ServiceDashboard = () => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();
  const [dashboard, setDashboard] = useState<HomeServiceDashboard>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetch();
  }, []);

  const fetch = () => {
    ApiService.home.getServiceDashboard().then((response) => {
      setDashboard(response);
      setLoading(false);
    });
  };

  return (
    <Card header={"Services"}>
      <Stack direction="column" spacing="xl">
        <Stack direction="column" spacing="sm">
          <Typography variant="h5" fontWeight={(theme) => theme.typography.fontWeightLight}>
            This Month
          </Typography>

          <Box>
            <Grid ref={breakpointsRef} container spacing="lg">
              <Grid item xs={setBreakpoints({ md: 8, xs: 12 })} display="flex" alignItems={"center"}>
                <ServiceChart rows={dashboard?.thisMonthRows} loading={loading} />
              </Grid>
              <Grid item xs={setBreakpoints({ md: 4, xs: 12 })} display="flex" alignItems={"center"}>
                <ServiceTable rows={dashboard?.thisMonthRows} loading={loading} />
              </Grid>
            </Grid>
          </Box>
        </Stack>

        <Stack direction="column" spacing="sm">
          <Typography variant="h5" fontWeight={(theme) => theme.typography.fontWeightLight}>
            Previous Month
          </Typography>

          <Box>
            <Grid ref={breakpointsRef} container spacing="lg">
              <Grid item xs={setBreakpoints({ md: 8, xs: 12 })} display="flex" alignItems={"center"}>
                <ServiceChart rows={dashboard?.previousMonthRows} loading={loading} />
              </Grid>
              <Grid item xs={setBreakpoints({ md: 4, xs: 12 })} display="flex" alignItems={"center"}>
                <ServiceTable rows={dashboard?.previousMonthRows} loading={loading} />
              </Grid>
            </Grid>
          </Box>
        </Stack>

        {/* <Grid ref={breakpointsRef} container>
          <Grid item xs={setBreakpoints({ md: 6, xs: 12 })}>
            <ServiceChart title="This Month" rows={dashboard?.thisMonthRows} loading={loading} />
          </Grid>
          <Grid item xs={setBreakpoints({ md: 6, xs: 12 })}>
            <ServiceChart title="Previous Month" rows={dashboard?.previousMonthRows} loading={loading} />
          </Grid>
        </Grid> */}
      </Stack>
    </Card>
  );
};
